export enum MaatNcqStatus {
  draft = 'draft',
  new = 'new',
  deleted = 'deleted',
  informationRequested = 'informationrequested',
  informationOverdue = 'informationoverdue',
  informationProvided = 'informationprovided',
  referredToSpo = 'referredtospo',
  spoInformationRequested = 'spoinformationrequested',
  spoInformationOverdue = 'spoinformationoverdue',
  spoInformationProvided = 'spoinformationprovided',
  referredToMgr = 'referredtomgr',
  completed = 'completed'
}


export const MaatNcqStatusDescriptions: Record<MaatNcqStatus, string> = {
  [MaatNcqStatus.draft]: 'Draft',
  [MaatNcqStatus.new]: 'New',
  [MaatNcqStatus.deleted]: 'Deleted',
  [MaatNcqStatus.informationRequested]: 'Info Req',
  [MaatNcqStatus.informationOverdue]: 'Info Overdue',
  [MaatNcqStatus.informationProvided]: 'Info Prov',
  [MaatNcqStatus.referredToSpo]: 'Referred To SPO',
  [MaatNcqStatus.spoInformationRequested]: 'SPO Info Req',
  [MaatNcqStatus.spoInformationOverdue]: 'SPO Info Overdue',
  [MaatNcqStatus.spoInformationProvided]: 'SPO Info Prov',
  [MaatNcqStatus.referredToMgr]: 'Referred To Mgr',
  [MaatNcqStatus.completed]: 'Completed'
};

export const MaatNcqStatusByDescriptions: Record<string, MaatNcqStatus> =
  Object.entries(MaatNcqStatusDescriptions).reduce((o, [key, value]) => { o[value] = key; return o; }, {});
